<template>
  <div class="d-flex-column justify-start align-start gap-8">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ $t("order.card.keystoneLvl") }}
      </label>
      <ItemTooltip :text="$t('new.select_desired_keystone')" />
    </div>
    <DropDown
      :drop-items="keystones"
      :img="'keystone'"
      :select-drop-item="selectKeystone"
      :selected-item="checkoutStore.getDetails?.desiredKeystone"
      v-if="!$isMobile() && !$isTablet()"
    />
    <BSPicker
      v-else-if="$isMobile() || $isTablet()"
      :title="$t('order.card.keystoneLvl')"
      :show-title="false"
      :items="keystones"
      item-key="id"
      :selected-item="checkoutStore.getDetails?.desiredKeystone"
      :select-filter="selectKeystone"
      :allow-null="false"
    />
  </div>
</template>

<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
import BSPicker from "./BSPicker.vue";
import { calculateCurrency } from "~/calculate/calculatePrice";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const userStore = useUserStore();
const keystones = computed(() => {
  const prices = gameStore.getGamePack.prices || [];
  if (prices.length > 0) {
    return prices.reduce((acc, value) => {
      return {
        ...acc,
        [value.slab]: `<div class='d-flex-row space-between'>
        <p>${value.title}</p> <p class='t-blue text-capitalize'>${renderPrice(
          value
        )}</p>
        </div>`,
      };
    }, {});
  }
  return {};
});

const renderPrice = (packOption) => {
  const price = parseFloat(calculateCurrency(packOption.price)).toFixed(2);
  return `${userStore.getUserCurrencyCode}${price}`;
};

const selectKeystone = (key, value) => {
  checkoutStore.setDetails({
    ...checkoutStore.getDetails,
    desiredKeystone: parseInt(value),
  });
};
</script>
